// Patient Type Options
export const PATIENT_TYPE_OPTIONS = [
  { label: 'Clinical', value: 'CLINICAL' },
  { label: 'Aesthetic', value: 'AESTHETIC' },
  { label: 'LHR', value: 'LHR' },
] as const;

// Patient Status Options
export const PATIENT_STATUS_OPTIONS = [
  { label: 'One-time', value: 'ONE_TIME' },
  { label: 'Regular', value: 'REGULAR' },
  { label: 'Maintenance', value: 'MAINTENANCE' },
  { label: 'NRI', value: 'NRI' },
  { label: 'Ghost', value: 'GHOST' },
] as const;

// Gender Options
export const GENDER_OPTIONS = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Other', value: 'OTHER' },
] as const;

// Referred By Type Options
export const REFERRED_BY_TYPE_OPTIONS = [
  { label: 'Patient', value: 'PATIENT' },
  { label: 'Staff', value: 'STAFF' },
  { label: 'Doctor', value: 'DOCTOR' },
  { label: 'Other', value: 'OTHER' },
  { label: 'Family', value: 'FAMILY' },
  { label: 'Friend', value: 'FRIEND' },
  { label: 'Relative', value: 'RELATIVE' },
] as const;

// Conversion Status Options
export const CONVERSION_STATUS_OPTIONS = [
  { label: 'T-Converted', value: 'CONVERTED' },
  { label: 'T-Not Converted', value: 'NOT_CONVERTED' },
] as const;

// Filter Options
export const TYPE_FILTER_OPTIONS = PATIENT_TYPE_OPTIONS;
export const GENDER_FILTER_OPTIONS = GENDER_OPTIONS;
export const REFERRED_BY_TYPE_FILTER_OPTIONS = REFERRED_BY_TYPE_OPTIONS;
export const PATIENT_STATUS_FILTER_OPTIONS = PATIENT_STATUS_OPTIONS;
export const CONVERSION_STATUS_FILTER_OPTIONS = CONVERSION_STATUS_OPTIONS;